// **** import modules ****
// moment
import * as moment from "moment";
moment.locale("ja");

// WebAppBase
import app, { Klass, csl, u_ } from "./app";
import "./history";
import "@pressmedia/webappbase-plugin-popup";
/**********************************/
// import "@pressmedia/webappbase-plugin-exec";
/**** ↑ no cms **** use cms ↓ ****/
import "@pressmedia/tyrellmodule";
/**********************************/

// components
import vuwer from "./vuwer";
import "@@components/body";
import "@@components/siteHeader";
import "@@components/siteFooter";
import "@@cmscomponents/components/copyright";
import "@@cmscomponents/components/pageLoader";
import "@@components/breadcrumbs";
import "@@components/pageHeader";
import "@@components/pageMain";
import "@@components/scrollToPageTop";
import "@@components/nndPager";
import "@@components/groupBox";


// **** process ****
Object.assign(app, {
	_setNnd(nndData) {
		if( !u_.isObject(nndData) ) {
			throw new TypeError("arguments[0] must be object.");
		}
		
		this.nnd = {
			...nndData,
			
			/**
			 * 和暦変換関数
			 * @param {Integer} nnd
			 * @returns {String} wareki
			 */
			getDisp(nnd) {
				const len = this.config.wareki.length;
				const { unit } = this.config;
				let jnnd;
				
				for(let i = 0; i < len; i++) {
					const w = this.config.wareki[i];
					if(nnd >= w.startYear) {
						jnnd = nnd - w.startYear + 1;
						if(jnnd > 1) {
							jnnd = `${w.name}${jnnd}${unit}`;
						} else {
							jnnd = `${w.name}元${unit}`;
						}
						break;
					}
				}
				
				return jnnd || `${nnd}${unit}`;
			},
			
			jMap: {}
		};
			
		this.nnd.keys = this.nnd.list.map(data => {
			this.nnd.jMap[ String(data.nnd) ] = this.nnd.getDisp(data.nnd);
			return data.nnd;
		});
		
		return this;
	},
	
	// [on execute]
	async onExec(err, res) {
		await app.promiseForPolyfill;
		
		// [Google Analytics] pageviewイベントを送信
		!!this.gaAutoSendPageview && this.sendGaPageview();
		
		// ポップアップ
		!!this.popup && this.popup.init(this);
		
		if(err) {
			csl.warn("exec", "エラーのため処理を終了します", err);
			return false;
		}
		
		!this.now && ( this.now = moment() );
		
		// 年度設定
		this._setNnd(res.nnd);
		if(this.nnd.length) {
			this.nnd.active = this.nnd.keys[0];
		} else {
			const now = this.now.clone();
			(now.month() < 3) && now.subtract(1, "years");
			this.nnd.active = now.year();
		}
		
		csl.log.red("active nnd", this.nnd.active);
		
		
		// コンポーネントの準備
		const resVuwer = await vuwer.getReady();
		csl.log.blue("**** vuwer is ready. ****", resVuwer);
		
		// 初期状態をvuwerへ反映
		const state = Object.assign({}, app._GET);
		return vuwer.setState(state);
	},
	
	// [after execute]
	async afterExec() {
		await new Promise((resolve, reject) => {
			// 画像部分の描画時間を考慮して、処理を遅らせる
			vuwer.isReady ? setTimeout(resolve, 100) : reject();
		});
		
		// フッタを最下部にフィックス
		vuwer.fixBottom("siteFooter");
		
		csl.log.blue("**** app is ready. ****");
		
		await new Promise(resolve => setTimeout(resolve, 0));
		vuwer.$window.trigger("resize", [true]).trigger("scroll", [true]);
		csl.log.blue(
			`** page initialized: ${app.pageName || "{no pageName}"} **`
		);
	}
});

export default app;
export { Klass, csl, u_, vuwer };
